<template>
    <div class="loading-container">
        <i :style="'color:'+color" class="iconfont icon-jiazai loading"></i>
        <div :style="'color:'+color" class="text">{{title}}</div>
    </div>
</template>

<script>
    export default {
        name: "loading",
        props: {
            title: {
                type: String,
                default: "正在加载"
            },
            color:{
                type:String,
                default:"#717171",
            }
        }
    }
</script>

<style scoped lang="less">
    .loading-container {
        text-align: center;
        padding-top: 50px;
        .loading {
            animation: loading 2s linear infinite;
            display: inline-block;
            width: 25px;
            height: 25px;
            font-size: 24px;
            text-align: center;
        }
        .text {
            font-size: 13px;
            color: #717171;
            padding: 5px;
        }
    }

    @keyframes loading {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>